// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"CarrelloFooterTitleRow_paragraph__xsbPG","hasOnlyHorizontalpadding":"CarrelloFooterTitleRow_hasOnlyHorizontalpadding__w9m9_"};